import { PyramidDiagram } from '@openx/components-core/lib/Charts/PyramidDiagram/PyramidDiagram.tsx';
import type { PyramidDiagramMetaStat } from '@openx/components-core/lib/Charts/PyramidDiagram/types.ts';
import { useMemo } from 'react';
import type { AgeGenderData } from '../../../data/chartTypes.ts';

const PYRAMID_HEIGHT = 220;

type AgeGenderChartProps = {
  data: AgeGenderData;
  isLoading?: boolean;
};

export const AgeGenderChart = ({ data, isLoading = false }: AgeGenderChartProps) => {
  const metaStats = useMemo<PyramidDiagramMetaStat[]>(
    () =>
      [
        { label: 'Unknown gender', value: data.unknownGender },
        { label: 'Unknown age', value: data.unknownAge },
      ]
        .filter((stat): stat is { label: string; value: number } => stat.value !== undefined)
        .map(({ label, value }) => ({ label, value: `${value}%` })),
    [data.unknownGender, data.unknownAge]
  );

  return (
    <PyramidDiagram
      title="Age & Gender"
      left={{ label: 'Male', totalPercent: data.maleShare }}
      right={{ label: 'Female', totalPercent: data.femaleShare }}
      rows={data.rows}
      metaStats={metaStats}
      isLoading={isLoading}
      height={PYRAMID_HEIGHT}
    />
  );
};
